import React from 'react';
import Ordinances from './Ordinances';  
import Resolutions from './Resolutions';  

const HomePage = () => (
  <div className="relative mx-auto max-w-full px-6 sm:px-8 lg:px-10 min-h-screen flex items-center justify-center bg-gray-200">
    <div className="flex flex-col items-center justify-center p-8 sm:p-12 md:p-16 text-center bg-white rounded-lg shadow-lg">
      <img
        src="/Antipolo_City_Logo.png"
        alt="Antipolo City Logo"
        className="w-32 h-auto mb-6"
      />
      <h1 className="text-3xl font-extrabold text-black-900 mb-6">
        Republic of the Philippines
        <br />
        CITY OF ANTIPOLO
        <br />
        Province of Rizal
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 w-full">
        <div className="col-span-1">
           <Ordinances />  
        </div>
        <div className="col-span-1">
          <Resolutions />  
        </div>
      </div>
    </div>
  </div>
);

export default HomePage;
